import { Controller } from "stimulus";

/*HOW TO REUSE
  1. Create a div or span with attached:
      - class="delete-confirm-container"
      - data-controller="bo-confirm-modal"
      - data-target="bo-confirm-modal.boConfirmModalController".
  2. Inside create :
      - a span containing the text to be displayed by attaching to it:
        - a data-target="bo-confirm-modal.visibleDeleteSubmit"
        - a data-action="click->bo-confirm-modal#toggleDeleteConfirmBox"
        - (optional) a data-confirmation-text="INSERT YOUR CUSTOM TEXT DISPLAYED IN THE MODAL",
      - the HTML submit button and hide it with a class "d-none" and a data-target="bo-confirm-modal.realDeleteBtn"
*/

export default class extends Controller {
  static targets = [
    "boConfirmModalController",
    "deleteAbortBtn",
    "deleteConfirmBtn",
    "deleteConfirmBox",
    "realDeleteBtn",
    "visibleDeleteSubmit",
  ];

  connect() {
    this.createDeleteModal();
  }

  createDeleteModal() {
    if (this.hasVisibleDeleteSubmitTarget) {
      const confirmationText = this.visibleDeleteSubmitTarget.dataset
        .confirmationText;
      let textToInsert;
      if (confirmationText && confirmationText.length >= 1) {
        textToInsert = confirmationText;
      } else {
        textToInsert = "Êtes vous sûr·e de vouloir supprimer cet élément ?";
      }

      const htmlToInsert = `<div class='delete-confirm-box hidden' data-target='bo-confirm-modal.deleteConfirmBox'>
        <div class='delete-confirm-message'>${textToInsert}</div>
        <div class='delete-confirm-button d-flex'>
          <div class='button-confirm' data-action='click->bo-confirm-modal#pressRealDeleteBtn' data-target='bo-confirm-modal.deleteConfirmBtn'>Supprimer</div>
          <div class='button-abort' data-action='click->bo-confirm-modal#toggleDeleteConfirmBox' data-target='bo-confirm-modal.deleteAbortBtn'>Annuler</div>
        </div>
      </div>`;
      this.boConfirmModalControllerTarget.insertAdjacentHTML(
        "beforeend",
        htmlToInsert
      );
    }
  }

  toggleDeleteConfirmBox() {
    this.deleteConfirmBoxTarget.classList.toggle("hidden");
  }

  pressRealDeleteBtn() {
    this.realDeleteBtnTarget.click();
  }
}
